import { render, staticRenderFns } from "./SalesPointListView.vue?vue&type=template&id=88b63574&"
import script from "./SalesPointListView.vue?vue&type=script&lang=js&"
export * from "./SalesPointListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports